import { types } from 'mobx-state-tree';

import { Storage } from '@socialbrothers/helpers';

export const AuthStore = types
  .model('AuthStore', {
    isAuthenticated: Storage.getIsAccessTokenValid(),
  })
  .actions((self) => {
    const actions = {
      setIsAuthenticated: (value: boolean) => {
        self.isAuthenticated = value;
      },
    };

    return actions;
  });
